const DEV = { label: 'dev', color: 'amber' }
const PROD = { label: 'prod', color: 'positive' }

const routes = [
  {
    path: '/login',
    name: 'login',
    meta: { requiresAuth: false },
    component: () => import('layouts/Login.vue'),
  },
  {
    path: '/',
    component: () => import('layouts/Master.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'home', component: () => import('pages/Home.vue'), meta: { bc: { name: 'Home', icon: 'mdi-home' }, no_sidebar: true, tags: [PROD] } },
      { path: 'dashboard', name: 'dashboard', component: () => import('pages/Dashboard.vue'), meta: { group: 1, bc: { name: 'Dashboard Manager' }, tags: [PROD] } },
      { path: 'campaigns/:id?', props: true, name: 'campaigns', component: () => import('pages/Campaigns.vue'), meta: { bc: { name: 'Campagne Marketing', icon: 'mdi-bullhorn' }, tags: [PROD] } },
      { path: 'actions', name: 'actions', component: () => import('pages/Actions.vue'), meta: { bc: { name: 'Processi di Gestione', icon: 'mdi-memory' }, tags: [PROD] } },
      { path: 'processes', name: 'processes', component: () => import('pages/Processes.vue'), meta: { bc: { name: 'Azioni', icon: 'mdi-camera-control' }, tags: [PROD] } },
      { path: 'instance/:instance_id/:status', name: 'instance', component: () => import('pages/Instance.vue'), props: true, meta: { bc: { name: 'Gestione Istanza' }, no_sidebar: true } },
      { path: 'counterpart/recalls', name: 'counterpart_recalls', component: () => import('pages/CounterpartRecalls.vue'), meta: { group: 2, bc: { name: 'Potenziali/Clienti' }, tags: [PROD] } },
      { path: 'counterpart/search', name: 'counterpart_search', component: () => import('pages/CounterpartSearch.vue'), meta: { group: 4, bc: { name: 'Potenziali/Clienti' }, tags: [PROD] } },
      { path: 'telemarketing/recalls', name: 'telemarketing_recalls', component: () => import('pages/TelemarketingRecalls.vue'), meta: { group: 2, bc: { name: 'Leads' }, tags: [PROD] } },
      { path: 'telemarketing/search', name: 'telemarketing_search', component: () => import('pages/TelemarketingSearch.vue'), meta: { group: 4, bc: { name: 'Leads' }, tags: [PROD] } },

      { path: 'release_notes', name: 'release_notes', component: () => import('pages/ReleaseNotes.vue'), meta: { bc: { name: 'Note di Rilascio', icon: 'mdi-alert-decagram' }, tags: [DEV] } },
      // { path: 'settings', name: 'settings', component: () => import('pages/tests/Configuration.vue'), meta: { group: 3, bc: { name: 'Impostazioni', icon: 'mdi-cog' }, tags: [DEV] } }
    ],
  },
  { path: '/402', component: () => import('pages/ErrorSubscriptionBlocked.vue') },
  { path: '/403', component: () => import('pages/Error403.vue') },
  { path: '/423', component: () => import('pages/ErrorAppNotActive.vue') },
  { path: '*', component: () => import('pages/Error404.vue') },
]

export default routes
